import * as turf from "@turf/turf";

export const fetchGisDataFromStorage = async (gisData) => {
  // Determine if gisData is a URL or JSON string
  try {
    const urlPattern = /^(http|https):\/\/[^ "]+$/;
    if (urlPattern.test(gisData)) {
      // gisData is a URL, fetch the JSON data from the URL

      console.log(gisData);
      const response = await fetch(gisData);
      const data = await response.text();
      console.log(data);

      const jsonData = JSON.parse(data);
      console.log(jsonData);

      return jsonData;
    }
    // gisData is a JSON string, parse it directly
    return JSON.parse(gisData);
  } catch (error) {
    console.error("Error fetching or parsing gisData:", error);
    return [];
  }
};

export const calculateAreaSize = (geojson) => {
  console.log(geojson);
  try {
    const featureCollection = JSON.parse(geojson);
    // Calculate the total area
    let totalArea = 0;
    featureCollection.features.forEach((feature) => {
      totalArea += turf.area(feature);
    });

    console.log(totalArea);
    // Normalize the area to a 1-10 scale
    const minArea = 50; // 50 square meters
    const maxArea = 1000000; // 20,000 square meters
    let normalizedSize = 1 + (9 * (totalArea - minArea)) / (maxArea - minArea);

    // Ensure the size is within the bounds of 1 to 10
    normalizedSize = Math.max(1, Math.min(10, normalizedSize));

    console.log(`Normalized Size: ${normalizedSize}`);
  } catch (err) {}
};
